"use strict";

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.installKarrotBridgeDriver = void 0;

var events_1 = __importDefault(require("events/"));

var camelcase_keys_1 = __importDefault(require("camelcase-keys"));

var makeId_1 = require("./core/makeId");

var getCurrentEnvironment_1 = require("./core/getCurrentEnvironment");

function installKarrotBridgeDriver() {
  var _this = this;

  var listeners = [];
  var globalEventEmitter = new events_1.default.EventEmitter();
  var globalSubscriptionDisposer = null;

  var postMessage = function postMessage(message) {
    var _a, _b;

    switch ((0, getCurrentEnvironment_1.getCurrentEnvironment)()) {
      case "Android":
        (_a = window.AndroidFunction) === null || _a === void 0 ? void 0 : _a.messageHandler(JSON.stringify(message));
        break;

      case "Cupertino":
        (_b = window.webkit) === null || _b === void 0 ? void 0 : _b.messageHandlers.messageHandler.postMessage(JSON.stringify(message));
        break;

      case "Web":
        console.warn("KarrotBridge의 통신 드라이버는 일반 데스크탑, 모바일 브라우저 환경을 지원하지 않아요." + " 현재 환경이 당근마켓 WebView 환경인지 확인해주세요.");
        break;
    }
  };

  var addMessageListener = function addMessageListener(listener) {
    listeners.push(listener);
    return function dispose() {
      var i = listeners.findIndex(function (l) {
        return l === listener;
      });
      listeners.splice(i, 1);
    };
  };

  var onMessage = function onMessage(message) {
    if (!message) {
      return console.error("메시지가 빈 채로 도착했어요");
    }

    listeners.map(function (l) {
      return l(message);
    });
  };

  var onQueried = function onQueried(queryName, requestBody) {
    var id = (0, makeId_1.makeId)();
    var message = {
      id: id,
      type: queryName,
      payload: requestBody
    };
    postMessage(message);
    return new Promise(function (resolve, reject) {
      var dispose = addMessageListener(function (arrivedMessage) {
        if (arrivedMessage.id === message.id) {
          dispose();

          if ("error" in arrivedMessage) {
            reject(new Error(arrivedMessage.error));
          } else {
            resolve((0, camelcase_keys_1.default)(arrivedMessage.payload, {
              deep: true
            }));
          }
        }
      });
    });
  };

  var onSubscribed = function onSubscribed(subscriptionName, requestBody, listener) {
    var id = (0, makeId_1.makeId)();
    var message = {
      id: id,
      type: subscriptionName,
      payload: requestBody
    };
    postMessage(message);
    return addMessageListener(function (arrivedMessage) {
      if (arrivedMessage.id === message.id) {
        if ("error" in arrivedMessage) {
          listener(new Error(arrivedMessage.error), null);
        } else {
          listener(null, (0, camelcase_keys_1.default)(arrivedMessage.payload, {
            deep: true
          }));
        }
      }
    });
  };

  var subscriptionResponseListener = function subscriptionResponseListener(error, response) {
    var _a;

    if (error) {
      throw error;
    }

    if (!((_a = response === null || response === void 0 ? void 0 : response.stream) === null || _a === void 0 ? void 0 : _a.eventName)) {
      throw new Error("이벤트 이름을 찾을 수 없습니다");
    }

    var eventName = response.stream.eventName;

    if (response.stream.data) {
      globalEventEmitter.emit(eventName, JSON.parse(response.stream.data));
    } else {
      globalEventEmitter.emit(eventName, undefined);
    }
  };

  var pickImages = function pickImages() {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = (0, getCurrentEnvironment_1.getCurrentEnvironment)();
              _context.next = _context.t0 === "Cupertino" ? 3 : 4;
              break;

            case 3:
              return _context.abrupt("return", pickImagesInCupertino({
                onQueried: onQueried
              }));

            case 4:
              return _context.abrupt("return", pickImagesInAndroid());

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var subscribeStream = function subscribeStream(eventName, listener) {
    if (!globalSubscriptionDisposer) {
      globalSubscriptionDisposer = driver.onSubscribed("REQ.STREAM.SUBSCRIBE", {}, subscriptionResponseListener);
    }

    var emitter = globalEventEmitter.on(eventName, listener);
    return function dispose() {
      emitter.off(eventName, listener);
    };
  };

  var driver = {
    getCurrentEnvironment: getCurrentEnvironment_1.getCurrentEnvironment,
    postMessage: postMessage,
    addMessageListener: addMessageListener,
    onMessage: onMessage,
    onQueried: onQueried,
    onSubscribed: onSubscribed,
    compat: {
      pickImages: pickImages,
      subscribeStream: subscribeStream
    }
  };

  if (typeof window !== "undefined") {
    if (window.native) {
      throw new Error("KarrotBridge의 통신 드라이버가 이미 설치되어 있어요." + " 기존에 설치된 드라이버를 덮어쓰므로 비정상적인 작동이 있을 수 있어요." + " installKarrotBridgeDriver가 여러번 호출되고 있는지 확인해주세요." + " (<React.StrictMode />의 영향일 수 있어요.)");
    }

    window.native = driver;
  }

  function uninstall() {
    if (typeof window !== "undefined") {
      delete window.native;
    }
  }

  return {
    driver: driver,
    uninstall: uninstall
  };
}

exports.installKarrotBridgeDriver = installKarrotBridgeDriver;

var pickImagesInAndroid = function pickImagesInAndroid() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var fileList, blobs, i;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return new Promise(function (resolve) {
              var input = document.createElement("input");
              input.type = "file";
              input.multiple = true;
              input.style.display = "none";
              input.accept = "image/*";
              input.addEventListener("change", function () {
                resolve(this.files);
              });
              document.body.append(input);
              input.click();
            });

          case 2:
            fileList = _context2.sent;

            if (fileList) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", []);

          case 5:
            blobs = [];

            for (i = 0; i < fileList.length; i++) {
              blobs.push(fileList[i]);
            }

            return _context2.abrupt("return", blobs);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var pickImagesInCupertino = function pickImagesInCupertino(_ref) {
  var onQueried = _ref.onQueried;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var _a, response, imgs, canvases, blobs;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return onQueried("REQ.IMAGE.PICK", {});

          case 2:
            response = _context3.sent;

            if ((_a = response === null || response === void 0 ? void 0 : response.image) === null || _a === void 0 ? void 0 : _a.images) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", []);

          case 5:
            _context3.next = 7;
            return Promise.all(response.image.images.map(function (image) {
              return image.uri;
            }).map(function (imageUrl) {
              var img = document.createElement("img");
              img.src = imageUrl;
              img.crossOrigin = "anonymous";
              return img;
            }).map(function (img) {
              return new Promise(function (resolve) {
                img.onload = function () {
                  resolve(img);
                };
              });
            }));

          case 7:
            imgs = _context3.sent;
            canvases = imgs.map(function (img) {
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              var imgWidth = img.naturalWidth;
              var imgHeight = img.naturalHeight;
              canvas.width = imgWidth;
              canvas.height = imgHeight;
              ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
              return canvas;
            });
            _context3.next = 11;
            return Promise.all(canvases.map(function (canvas) {
              return new Promise(function (resolve) {
                canvas.toBlob(function (blob) {
                  resolve(blob);
                });
              });
            }));

          case 11:
            blobs = _context3.sent;
            imgs.forEach(function (img) {
              img.remove();
            });
            return _context3.abrupt("return", blobs.filter(function (blob) {
              return !!blob;
            }));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};